export const getPhoneNumberHref = (number: string) => {
    return number
    .replace(/\s+/g, '') //remove spaces
    .replace(/-/g, '') //remove dashes
    .replace(/\(/g, '') //remove ( brackets
    .replace(/\)/g, ''); //remove ) brackets
}